import { Link } from 'react-router-dom';
import { PackageSearch } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { cn } from '@/lib/utils';

export interface ProductNotFoundCardProps {
  readonly title: string;
  readonly description: string;
  readonly ctaLabel: string;
  readonly testIdPrefix?: string;
}

export function ProductNotFoundCard({
  title,
  description,
  ctaLabel,
  testIdPrefix = 'product',
}: ProductNotFoundCardProps) {
  return (
    <div className="flex min-h-[60vh] items-center justify-center">
      <div
        className={cn(
          'bg-sand-100 dark:bg-sand-800 rounded-card shadow-card w-full max-w-md p-10 text-center',
        )}
        data-testid={`${testIdPrefix}-not-found`}
      >
        <PackageSearch
          className="text-sand-400 mx-auto mb-4 h-12 w-12"
          strokeWidth={1.5}
          aria-hidden="true"
        />
        <h2 className="font-display text-sand-700 dark:text-sand-100 mb-2 text-xl font-semibold">
          {title}
        </h2>
        <p className="text-sand-500 dark:text-sand-400 mb-6 text-sm">{description}</p>
        <Button asChild>
          <Link to="/products" data-testid={`${testIdPrefix}-not-found-cta`}>
            {ctaLabel}
          </Link>
        </Button>
      </div>
    </div>
  );
}
